<template>
    <div class="versions" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <div class="header">
            <p>{{ $t("chatbotv2.versionHistory") }}</p>
            <span
                style="
                    display: flex;
                    flex-direction: row;
                    justify-content: end;
                    text-align: center;
                    align-items: center;
                "
            >
                <a-icon style="font-size: 21px" type="close" v-if="bar !== 0" @click="$emit('close-menu', 0)" />
            </span>
        </div>
        <div class="version">
            <div
                class="list-item"
                v-for="version in versions($route.params.id)"
                @click="changeVersion(version.version)"
                :class="{ active: version.version === selectedBoard }"
            >
                <VersionCard
                    @changeVersion="changeVersion"
                    :story-id="storyId"
                    :version-names="versionNames"
                    :version="version"
                    :selected-board="selectedBoard"
                    @selected-name="nameControl"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import VersionCard from "./VersionCard";

export default {
    name: "VersionSwitcher",
    components: { VersionCard },
    props: ["bar", "storyId"],
    data() {
        return {
            versionNames: [],
        };
    },
    computed: {
        ...mapGetters({
            allBoards: "CB/allBoards",
            versions: "CB/versions",
        }),
        ...mapState({
            selectedBoard: (state) => state.CB.selectedBoard,
        }),
    },
    methods: {
        ...mapActions({
            getStory: "CB/getStory",
        }),
        changeVersion(version) {
            this.getStory({ id: this.$route.params.id, version });
            this.$router.push(`/chatbot/story/${this.$route.params.id}/${version}`);
        },
        nameControl(e) {
            const clearArray = this.versionNames.filter((name) => name !== e);
            this.versionNames = clearArray;
        },
    },
    mounted() {
        this.versions(this.$route.params.id).map((element) => this.versionNames.push(element.version));
    },
};
</script>

<style lang="scss" scoped>
.versions {
    box-shadow: 0 4px 20px #00000040;
    background: #ffffff;
    border-radius: 4px;
    width: 100%;
    overflow-y: auto;
    min-width: 440px;
    max-height: 523px;
    padding: 0 30px;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center !important;
        width: 100%;
        height: 80px;
        font-weight: 600;

        p {
            font-size: 18px;
            line-height: 23px;
            margin: 0;
        }
    }

    .version {
        margin-bottom: 7px;

        .list-item {
            border: 1px solid #dfdfdf;
            padding: 30px 20px;
            border-radius: 5px;
            cursor: pointer;
            user-select: none;
            margin-bottom: 30px;
            position: relative;
            display: flex;

            &.active {
                background-color: #e8eef2;
            }
        }
    }
}
</style>
